export default __webpack_public_path__ + "static/media/servicio.1acaaf40.svg";